import React from 'react'
import { useQuery } from '@apollo/client'
import Typography from '@material-ui/core/Typography'
import CircularProgress from '@material-ui/core/CircularProgress'
import Grid from '@material-ui/core/Grid'
import EventsGrid from './components/EventsGrid'
import { GET_EVENTS } from '../../network/events/queries'
import { useStyles } from './styles'

const EventsPage = () => {
  const classes = useStyles()

  const { loading, data } = useQuery(GET_EVENTS, {
    fetchPolicy: 'no-cache'
  })

  return loading || !data?.coordinator.event.list ? (
    <div className={classes.loader}>
      <CircularProgress color='inherit' />
    </div>
  ) : (
    <div className={classes.root}>
      <Grid container spacing={6}>
        <Grid container item xs={12}>
          <Typography variant='h2' component='div'>
            Events
          </Typography>
        </Grid>
        <Grid container item xs={12}>
          <EventsGrid events={data?.coordinator.event.list} />
        </Grid>
      </Grid>
    </div>
  )
}

export default EventsPage
